/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const Row = styled.div`
  display: flex;
  margin-bottom: ${token('space.200')};
`;

export const Column = styled.div`
  flex: 1;
  min-width: 0;
  padding: 0 ${token('space.100')};

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const Label = styled.div`
  font: ${token('font.body.UNSAFE_small')};
  font-weight: ${token('font.weight.semibold')};
  color: ${token('color.text.subtlest')};
  margin-top: 0;
`;

export const Value = styled.span`
  ${overflowEllipsis()};
`;

export const Card = styled.div`
  & + & {
    margin-top: ${token('space.150')};
  }
`;
